<template>
  <div class="dali-index">
    <div class="dali-title">
      <div class="details-intro">
          <div class="title">
            <div class="text">大理智慧管理平台</div>
            <div class="title-btn" @click="go()">进入</div>
          </div>
      </div>
    </div>
    <div class="dali-infos">
      <div class="subtitle">
        【 大理介绍 】
      </div>
      <div class="dali-content">
        <div class="par">大理市，是大理白族自治州的首府，地处云南省西部，云贵高原上的洱海平原，苍山之麓，洱海之滨，是古代南诏国和大理国的都城，作为古代云南地区的政治、经济和文化中心，时间长达五百余年。根据第七次人口普查数据，截至2020年11月1日零时，大理市常住人口为771128人。</div>
        <div class="par">2020年，地区生产总值472.84亿元，完成规模以上固定资产投资269.06亿元、增长8.5%，争取上级补助资金35.5亿元，盘活财政存量资金1.97亿元，完成一般公共预算收入37.53亿元、增长0.03%，一般公共预算支出70.53亿元。</div>
      </div>
      <div class="subtitle">
        项目展示
      </div>
      <div class="dali-content">
        <img class="dali-img" :src="img" alt="">
      </div>
      <div class="summary">
        本项目属于“大理市智慧城管总平台”的一部分，是依托物联网技术与移动互联网技术，对环卫管理所涉及到的人、车、物、事进行全过程实时管理的软件系统，服务内容包括垃圾分类、环卫作业、餐厨垃圾收运、垃圾转运、垃圾处置、智慧公厕、建筑垃圾模块。
      </div>
    </div>
  </div>
</template>

<script>
import contentImg from "@/assets/images/dali/dl-pro-img.png";
export default {
  data() {
    return {
      img: contentImg
    }
  },
  methods: {
    go() {
      this.$router.push({path: '/DaliComprehensive'})
      // this.$router.push({ path: '/ConsultDetails', query: { id: item.id, name: 'PT_CONSULT', index: 5 } })
    }
  },
}
</script>

<style lang="scss" scoped>

.dali-index {
  padding: 64px 12%;
  color: #333;
}
  .dali-title {
  height: 120px;
  margin-top: 15px;

  .details-intro {
    width: 100%;

  }
  .title {
    justify-content: space-between;
    display: flex;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #333;
    margin-bottom: 15px;
    line-height: 120px;
    padding: 0 30px;
  }
  .text {
    font-size: 36px;
  }
  .title-btn {
    cursor:pointer;
    width: 80px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-color: rgba(217, 0, 27, 1);
    font-weight: 400;
    font-size: 18px;
    color: #fff;
    border-radius: 5px;
    
  }
}
.dali-infos{
  padding: 35px 135px 0 180px;
  font-style: normal;
  .subtitle {
    font-size: 17px;
    font-weight: 650;
    margin-bottom: 20px;
  }
  .par {
    word-wrap: break-word;
    text-indent: 32px;
    line-height: 24px;
    font-size: 16px;
    letter-spacing: 0.5px;
  }
  .dali-content {
    margin-bottom: 40px;
  }

  .dali-img {
    width: 100%;
  }
  .summary {
    font-weight: 400;
    font-size: 20px;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/DaliIndex.vue